import { InitialiseData } from 'src/app/models/state.model'

export interface InitializeState extends InitialiseData {}

export const initialInitializeState: InitializeState = {
  initialized: false,
  taskTypes: undefined,
  user: undefined,
  uiStatusMapping: undefined,
  companySettings: undefined,
  newJoineeActivityDetails: undefined,
  feedbackList: undefined,
  pendingQueriesCount: 0,
  screenConfigs: undefined,
  companyLogoUrl: undefined,
  companyGroupCode: undefined,
  authType: undefined
}
